// modules
import { createSelector } from 'reselect'
import { flow, find, get } from 'lodash'

// constants
import { QUICK_MESSAGES_MANAGEMENT_TYPES } from 'src/constants'

const quickMessagesManagement = (state) =>
  get(state, ['admin', 'quickMessagesManagement'], {})

const userCompanyEnglishLanguage$ = (state = {}) => {
  const englishLang = state?.user?.profile?.companyLanguages?.find(
    ({ title }) => title === 'English'
  )

  return englishLang?.uuid || null
}

export const quickMessagesManagementList$ = createSelector(
  quickMessagesManagement,
  ({ quickMessagesManagementList = [] }) => quickMessagesManagementList
)

export const quickMessagesManagementListModalRadio$ = createSelector(
  quickMessagesManagementList$,
  userCompanyEnglishLanguage$,
  (quickMessagesManagementList = [], englishUuid = null) => [
    ...quickMessagesManagementList.map(({ uuid, label, translations }) => {
      const message = flow(
        (translations = []) =>
          find(translations, { language: { uuid: englishUuid } }),
        (translation = {}) => get(translation, ['message'], '')
      )(translations)

      return {
        key: uuid,
        title: label,
        value: uuid,
        message
      }
    }),
    {
      key: 'custom',
      title: 'Custom',
      value: 'custom',
      message: ''
    }
  ]
)

export const patientQuickMessagesManagementList$ = createSelector(
  quickMessagesManagementList$,
  (quickMessagesManagementList = []) =>
    quickMessagesManagementList.filter(
      ({ type }) => QUICK_MESSAGES_MANAGEMENT_TYPES.get('patient') === type
    )
)

export const caregiverQuickMessagesManagementList$ = createSelector(
  quickMessagesManagementList$,
  (quickMessagesManagementList = []) =>
    quickMessagesManagementList.filter(
      ({ type }) => QUICK_MESSAGES_MANAGEMENT_TYPES.get('caregiver') === type
    )
)

export const quickMessagesManagementEditItem$ = createSelector(
  quickMessagesManagement,
  ({ quickMessagesManagementEditItem = {} }) => quickMessagesManagementEditItem
)
